import { Button, Header } from '@kanda-libs/ks-design-library';
import useHelpModal from 'components/HelpModal/useHelpModal';
import LeadSlideUpModal from '../LeadSlideUpModal';
import useMobileHeader from './useMobileHeader';

const MobileHeader: React.FunctionComponent = function ({}) {
  const { openSlideUp, onClick } = useMobileHeader();
  const { showHelpModal } = useHelpModal();
  return (
    <Header.Base
      hideNumber
      help={(e) => {
        if (e && typeof e.stopPropagation === 'function') {
          e.stopPropagation();
        }
        showHelpModal();
      }}
      options={[
        <Button.Icon
          id="job-details-mobile-header-mobile"
          key="more"
          icon="more"
          onClick={openSlideUp}
        />,
      ]}
    >
      <Button.Icon
        id="lead-details-mobile-header-back"
        onClick={onClick}
        icon="chevron-left"
        className="-ml-3"
      />
      <LeadSlideUpModal />
    </Header.Base>
  );
};

export default MobileHeader;
